import type { InsuranceScenarioGeneral } from '@/general/src/insuranceScenario/shared.js'

export const personalKaskoByOsagoVskGeneral = {
  title: 'КАСКО физ. лица в ВСК из ОСАГО',
  titleShort: 'ВСК (из ОСАГО)',
  insuranceProvider: 'vsk',
  insuranceType: 'personalKasko',
  insuranceCustomerType: 'personal',
  insuranceScenarioKey: 'personalKaskoByOsagoVsk',
} satisfies InsuranceScenarioGeneral
